<mat-form-field appearance="outline" class="password-wrapper"
  [class.invalid]="isPasswordInvalid">

  <mat-label *ngIf="withPlaceholder">{{placeholder}}</mat-label>

  <div class="input-container">
      <input
      matInput
      [type]="hide ? 'password' : 'text'"
      class="password-input"
      [value]="value"
      [attr.autocomplete]="autocomplete"
      (blur)="onTouched()"
      (input)="onInput($event.target.value)"
  />
    <button mat-icon-button
            matSuffix
            *ngIf="value"
            type="button"
            class="toggle-btn"
            (click)="hide = !hide">
            <svg-icon [src]="hide ? '/assets/icons/password-hide.svg' : '/assets/icons/password-unhide.svg'" class="hide-icon"></svg-icon>
    </button>
  </div>

</mat-form-field>
